<template>
  <div
    class="skeleton-wrapper"
    :class="{ }"
    :style="cssVars" >
    <span
      class="skeleton flex center-all" >{{ placeholder }}</span>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'SkeletonWrapper',
  components: {
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: SBColors.greyPrimary,
    },
    color: {
      type: String,
      default: SBColors.skeletonColor,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '20px',
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: Number,
      default: 10,
    },
    fill: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: Number,
      default: 0,
    },
    margin: {
      type: Number,
      default: 0,
    },
    border: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--width': `${this.width}`,
        '--height': `${this.height}`,
        '--text-color': this.textColor,
        '--color': this.fill ? this.color : 'transparent',
        '--shadow': this.shadow ? '0 1px 3px 0 rgba(48, 54, 70, 0.1)' : 'none',
        '--radius': `${this.radius}px`,
        '--bottom-radius': `${this.bottomRadius}px`,
        '--border': this.border ? `2px solid ${this.color}` : 'none',
        '--padding': `${this.padding}px`,
        '--margin': `${this.margin}px`,
      };
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.skeleton-wrapper {
  * {
    color: var(--text-color);
  }

  box-shadow: var(--shadow);
  border-radius: var(--radius);
  border: var(--border);
  padding: var(--padding);
  margin: var(--margin);
  width: var(--width);
  height: var(--height);

  .skeleton {
    background-color: var(--color);
    border-radius: var(--radius);
    width: 100%;
    height: 100%;
  }
}
</style>
